import React from "react";

export default function Datenschutz() {
  return (
    <main className="mx-auto max-w-4xl px-6 py-12 text-gray-800 leading-relaxed">
      <h1 className="text-2xl font-bold mb-6">Datenschutzerklärung</h1>
      <p>
        Wir, <strong>GVSI Clean & Care</strong>, nehmen den Schutz Ihrer
        persönlichen Daten sehr ernst. Die Verarbeitung erfolgt nach den
        gesetzlichen Vorschriften (DSGVO, BDSG).
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">1. Verantwortlicher</h2>
      <p>
        GVSI Clean & Care<br />
        Geschäftsführer: Armanda Gashi (CEO)<br />
        Rosenheim, 83024<br />
        Deutschland<br />
        
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">
        2. Erhebung und Speicherung personenbezogener Daten
      </h2>
      <p>
        Wir verarbeiten personenbezogene Daten (z. B. Name, Anschrift,
        Telefonnummer, E-Mail) nur, soweit dies zur Erbringung unserer
        Reinigungsdienstleistungen notwendig ist oder Sie uns diese im Rahmen
        einer Anfrage übermitteln.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">3. Zwecke</h2>
      <ul className="list-disc list-inside space-y-1">
        <li>Bearbeitung von Anfragen und Aufträgen</li>
        <li>Terminabsprachen</li>
        <li>Rechnungsstellung und Buchhaltung</li>
        <li>Erfüllung gesetzlicher Pflichten</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-3">
        4. Weitergabe an Dritte
      </h2>
      <p>
        Eine Weitergabe erfolgt nur, wenn es für die Vertragserfüllung notwendig
        ist (z. B. Steuerberater) oder wir gesetzlich verpflichtet sind.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">5. Rechte der Betroffenen</h2>
      <p>
        Sie haben das Recht auf Auskunft, Berichtigung, Löschung,
        Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerruf
        erteilter Einwilligungen. Beschwerden können an die zuständige
        Datenschutzaufsichtsbehörde gerichtet werden.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">6. Speicherdauer</h2>
      <p>
        Wir speichern Daten nur solange, wie es für die Erfüllung unserer
        vertraglichen und gesetzlichen Pflichten erforderlich ist.
      </p>
    </main>
  );
}
